/* ==========================================================================
   Footer 2026 — Clip
   - Acordeones en ≤991px: todos cerrados, uno abierto a la vez, animados.
   - "Leer más" / "Cerrar" del texto legal, animado.
   - Compatible con el editor de temas (recarga de sección y selección de bloques).
   El estado visual vive en el CSS (clase .is-open); aquí solo se agrega/quita.
   ========================================================================== */
(function () {
  var MQ = window.matchMedia('(max-width: 991px)');
  var DUR = 400; /* un poco más que la transición CSS (350ms) */

  function reflow(el) {
    return el.offsetHeight;
  }

  function init(root) {
    if (!root || root.hasAttribute('data-ft26-ready')) return;
    root.setAttribute('data-ft26-ready', '');

    /* ---------------- Acordeones ---------------- */
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-ft26-group]'));

    function parts(g) {
      return {
        t: g.querySelector('.ft26-group-toggle'),
        l: g.querySelector('.ft26-list'),
        c: g.querySelector('.ft26-chevron')
      };
    }

    function openList(l) {
      clearTimeout(l._ft26t);
      l.classList.add('is-open');
      l.style.height = l.scrollHeight + 'px';
      l._ft26t = setTimeout(function () {
        if (l.classList.contains('is-open')) l.style.height = 'auto';
      }, DUR);
    }

    function closeList(l) {
      if (!l.classList.contains('is-open')) return;
      clearTimeout(l._ft26t);
      l.style.height = l.scrollHeight + 'px';
      reflow(l);
      l.classList.remove('is-open');
      l.style.height = '';
    }

    function setOpen(g, open) {
      var p = parts(g);
      if (!p.t || !p.l) return;
      if (open) openList(p.l); else closeList(p.l);
      if (p.c) p.c.classList.toggle('is-open', open);
      p.t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function openOnly(g) {
      groups.forEach(function (o) {
        if (o !== g) setOpen(o, false);
      });
      setOpen(g, true);
    }

    function reset(p) {
      clearTimeout(p.l._ft26t);
      p.l.classList.remove('is-open');
      p.l.style.height = '';
      if (p.c) p.c.classList.remove('is-open');
    }

    function apply() {
      groups.forEach(function (g) {
        var p = parts(g);
        if (!p.t || !p.l) return;
        reset(p);
        if (MQ.matches) {
          p.t.setAttribute('role', 'button');
          p.t.setAttribute('tabindex', '0');
          p.t.setAttribute('aria-controls', p.l.id);
          p.t.setAttribute('aria-expanded', 'false');
        } else {
          p.t.removeAttribute('role');
          p.t.removeAttribute('tabindex');
          p.t.removeAttribute('aria-controls');
          p.t.removeAttribute('aria-expanded');
        }
      });
    }

    groups.forEach(function (g) {
      var p = parts(g);
      if (!p.t || !p.l) return;

      function toggle() {
        if (!MQ.matches) return;
        if (p.l.classList.contains('is-open')) setOpen(g, false);
        else openOnly(g);
      }

      p.t.addEventListener('click', toggle);
      p.t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });

      /* Editor de temas: al seleccionar un bloque en mobile, abrirlo */
      g.addEventListener('shopify:block:select', function () {
        if (MQ.matches) openOnly(g);
      });
    });

    if (MQ.addEventListener) MQ.addEventListener('change', apply);
    else if (MQ.addListener) MQ.addListener(apply);
    apply();

    /* ---------------- Texto legal: Leer más / Cerrar ---------------- */
    var btn = root.querySelector('.ft26-legal-toggle');
    var text = root.querySelector('.ft26-legal-text');

    if (btn && text) {
      var paras = text.querySelectorAll('.ft26-legal-lead, .ft26-legal-extra');
      var labelOpen = btn.getAttribute('data-label-open') || 'Leer más';
      var labelClose = btn.getAttribute('data-label-close') || 'Cerrar';

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        clearTimeout(text._ft26t);

        var start = text.offsetHeight;
        Array.prototype.forEach.call(paras, function (p) {
          p.classList.toggle('is-open', open);
        });
        text.style.height = 'auto';
        var end = text.offsetHeight;

        text.style.height = start + 'px';
        reflow(text);
        text.style.height = end + 'px';
        text._ft26t = setTimeout(function () {
          text.style.height = '';
        }, DUR);

        btn.textContent = open ? labelClose : labelOpen;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ft26]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Editor de temas: al recargar la sección, volver a inicializar */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector && e.target.querySelector('[data-ft26]');
    if (root) init(root);
  });
})();